define("shared/utils/media-adjustments/format-platform-name", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.formatPlatformName = formatPlatformName;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const PLATFORM_DISPLAY_NAMES = {
    tiktok: 'TikTok',
    instagram: 'Instagram',
    facebook: 'Facebook',
    pinterest: 'Pinterest',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
    threads: 'Threads',
    youtube: 'YouTube',
    snapchat: 'Snapchat'
  };
  function formatPlatformName(platform) {
    return PLATFORM_DISPLAY_NAMES[platform] ?? platform;
  }
});